import React, { useState, useEffect } from "react";
import styles from "./Home.module.scss";
import { RiLayoutGridFill } from "react-icons/ri";
import Logo from "../../Assets/img/logo.png";
import Footer from "../Hoc/Footer";
import homeslider1 from "../../Assets/img/homeslider1.svg";
import homeslider2 from "../../Assets/img/homeslider2.svg";
import homeslider3 from "../../Assets/img/homeslider3.svg";
import homeslider4 from "../../Assets/img/homeslider4.svg";
import homeslider5 from "../../Assets/img/homeslider5.svg";
import homeslider6 from "../../Assets/img/homeslider6.svg";
import edu from "../../Assets/img/edu.svg";
import work from "../../Assets/img/work.svg";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { AiOutlineFieldTime } from "react-icons/ai";
import { BsGlobe } from "react-icons/bs";
import { MdArrowBackIosNew } from "react-icons/md";
import Loader from "react-loader-spinner";

function Home() {
  const navigate = useNavigate();

  const [edu1, setEdu1] = useState([]);
  const [edu2, setEdu2] = useState([]);
  const [work1, setWork1] = useState([]);
  const [work2, setWork2] = useState([]);
  const [deadLineEdu1, setDeadLineEdu1] = useState("");
  const [deadLineEdu2, setDeadLineEdu2] = useState("");
  const [deadLineWork1, setDeadLineWork1] = useState("");
  const [deadLineWork2, setDeadLineWork2] = useState("");
  const [loader, setLoader] = useState(true);
  const [loader2, setLoader2] = useState(true);

  useEffect(() => {
    checkToken();
    getEdu();
    getWork();
  }, []);

  const checkToken = () => {
    if (localStorage.getItem("token") === null) {
      navigate("/login");
    }
  };

  const getEdu = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/show-select-time-studyOpportunity`
      )
      .then((res) => {
        console.log("edu", res);
        setEdu1(res.data[0]);
        setEdu2(res.data[1]);
        setLoader(false);

        // محاسبه ددلاین بعد از ست کردن state
        setTimeout(() => {
          calculateDeadline(res.data[0]?.deadline, setDeadLineEdu1);
          calculateDeadline(res.data[1]?.deadline, setDeadLineEdu2);
        }, 100);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const getWork = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/show-two-last-data-job-opportunity`
      )
      .then((res) => {
        console.log("work", res);
        setWork1(res.data.data[0]);
        setWork2(res.data.data[1]);
        setLoader2(false);

        setTimeout(() => {
          calculateDeadline(res.data.data[0]?.deadline, setDeadLineWork1);
          calculateDeadline(res.data.data[1]?.deadline, setDeadLineWork2);
        }, 100);
      })
      .catch((err) => {
        console.log(err);
        setLoader2(false);
      });
  };

  const calculateDeadline = (deadlineDate, setDeadline) => {
    if (!deadlineDate) return;
    const oneDay = 1000 * 60 * 60 * 24;
    const today = new Date();
    const deadline = new Date(deadlineDate.toString());
    const differenceMs = Math.abs(today - deadline);
    const date = Math.round(differenceMs / oneDay);
    setDeadline(date);
  };

  return (
    <>
      <div className={styles.home}>
        <div className={styles.homeBody}>
          <div className={styles.homeHeader}>
            <img className={styles.homeHeaderLogo} src={Logo} alt="" />
            <span>آریانا پارس</span>
            <div
              onClick={() => navigate("/profile")}
              className={styles.homeHeaderProfile}
            >
              <RiLayoutGridFill size={30} />
            </div>
          </div>

          <div className={styles.homeSlider}>
            <Swiper
              spaceBetween={0}
              slidesPerView={4.3}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide
                onClick={() => navigate("/make-resume")}
                className={styles.singleSlider}
              >
                <div className={styles.sliderDiv1}>
                  <img src={homeslider1} alt="home-item" />
                </div>
                <span>رزومه ساز</span>
              </SwiperSlide>

              <SwiperSlide
                onClick={() => navigate("/continents")}
                className={styles.singleSlider}
              >
                <div className={styles.sliderDiv2}>
                  <img src={homeslider2} alt="home-item" />
                </div>
                <span>دانستنی ها</span>
              </SwiperSlide>

              <SwiperSlide
                onClick={() => navigate("/cons-type")}
                className={styles.singleSlider}
              >
                <div className={styles.sliderDiv3}>
                  <img src={homeslider3} alt="home-item" />
                </div>
                <span>درخواست مشاوره</span>
              </SwiperSlide>

              <SwiperSlide
                onClick={() => navigate("/articles")}
                className={styles.singleSlider}
              >
                <div className={styles.sliderDiv4}>
                  <img src={homeslider4} alt="home-item" />
                </div>
                <span>مقالات</span>
              </SwiperSlide>

              <SwiperSlide
                onClick={() => navigate("/education")}
                className={styles.singleSlider}
              >
                <div className={styles.sliderDiv5}>
                  <img src={homeslider5} alt="home-item" />
                </div>
                <span>موقعیت تحصیلی</span>
              </SwiperSlide>

              <SwiperSlide
                onClick={() => navigate("/job")}
                className={styles.singleSlider}
              >
                <div className={styles.sliderDiv6}>
                  <img src={homeslider6} alt="home-item" />
                </div>
                <span>موقعیت شغلی</span>
              </SwiperSlide>
            </Swiper>
          </div>

          <div className={styles.homeMid}>
            {/* آخرین فرصت‌های شغلی */}
            <div className={styles.homeMidHeader}>
              <span>آخرین فرصت های شغلی</span> <div></div>
              <button onClick={() => navigate("/job")}>
                دیدن همه <MdArrowBackIosNew />
              </button>
            </div>

            <div className={styles.homeMidBody}>
              {loader2 ? (
                <div>
                  <Loader
                    type="TailSpin"
                    color="rgb(236, 177, 28)"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                deadLineWork1 && (
                  <div className={styles.homeMidBodyItem}>
                    {deadLineWork1 !== "" ? (
                      <Link
                        className={styles.link}
                        to={`/single-job/${work1?._id}`}
                      >
                        <div className={styles.cardImg}>
                          <img src={work} alt="" />
                        </div>
                        <div className={styles.cardText}>
                          <h2>
                            {work1?.title_fa ? work1?.title_fa : work1?.title}
                          </h2>
                          <p>{work1?.document}</p>
                          <div className={styles.cardUnderItems}>
                            <div className={styles.cardUnderItem}>
                              <BsGlobe />
                              {work1?.country}
                            </div>
                            <div className={styles.cardUnderItem}>
                              <AiOutlineFieldTime /> {deadLineWork1} روز
                            </div>
                          </div>
                        </div>
                      </Link>
                    ) : (
                      "موردی یافت نشد"
                    )}
                  </div>
                )
              )}

              {loader2 ? (
                <div>
                  <Loader
                    type="TailSpin"
                    color="rgb(236, 177, 28)"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                deadLineWork2 && (
                  <div className={styles.homeMidBodyItem}>
                    {deadLineWork2 !== "" ? (
                      <Link
                        className={styles.link}
                        to={`/single-job/${work2?._id}`}
                      >
                        <div className={styles.cardImg}>
                          <img src={work} alt="" />
                        </div>
                        <div className={styles.cardText}>
                          <h2>
                            {work2?.title_fa ? work2?.title_fa : work2?.title}
                          </h2>
                          <p>{work2?.document}</p>
                          <div className={styles.cardUnderItems}>
                            <div className={styles.cardUnderItem}>
                              <BsGlobe />
                              {work2?.country}
                            </div>
                            <div className={styles.cardUnderItem}>
                              <AiOutlineFieldTime /> {deadLineWork2} روز
                            </div>
                          </div>
                        </div>
                      </Link>
                    ) : (
                      "موردی یافت نشد"
                    )}
                  </div>
                )
              )}
            </div>

            {/* آخرین فرصت‌های تحصیلی */}
            <div className={styles.homeMidHeader}>
              <span>آخرین فرصت های تحصیلی</span> <div></div>
              <button onClick={() => navigate("/education")}>
                دیدن همه <MdArrowBackIosNew />
              </button>
            </div>

            <div className={styles.homeMidBody}>
              {loader ? (
                <div>
                  <Loader
                    type="TailSpin"
                    color="rgb(236, 177, 28)"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                deadLineEdu1 && (
                  <div className={styles.homeMidBodyItem}>
                    {deadLineEdu1 !== "" ? (
                      <Link
                        className={styles.link}
                        to={`/education-single/${edu1?._id}`}
                      >
                        <div className={styles.cardImg}>
                          <img src={edu} alt="" />
                        </div>
                        <div className={styles.cardText}>
                          <h2>
                            {edu1?.title_fa ? edu1?.title_fa : edu1?.title}
                          </h2>
                          <p>{edu1?.document}</p>
                          <div className={styles.cardUnderItems}>
                            <div className={styles.cardUnderItem}>
                              <BsGlobe />
                              {edu1?.country}
                            </div>
                            <div className={styles.cardUnderItem}>
                              <AiOutlineFieldTime /> {deadLineEdu1} روز
                            </div>
                          </div>
                        </div>
                      </Link>
                    ) : (
                      "موردی یافت نشد"
                    )}
                  </div>
                )
              )}

              {loader ? (
                <div>
                  <Loader
                    type="TailSpin"
                    color="rgb(236, 177, 28)"
                    height={80}
                    width={80}
                  />
                </div>
              ) : (
                deadLineEdu2 && (
                  <div className={styles.homeMidBodyItem}>
                    {deadLineEdu2 !== "" ? (
                      <Link
                        className={styles.link}
                        to={`/education-single/${edu2?._id}`}
                      >
                        <div className={styles.cardImg}>
                          <img src={edu} alt="" />
                        </div>
                        <div className={styles.cardText}>
                          <h2>
                            {edu2?.title_fa ? edu2?.title_fa : edu2?.title}
                          </h2>
                          <p>{edu2?.document}</p>
                          <div className={styles.cardUnderItems}>
                            <div className={styles.cardUnderItem}>
                              <BsGlobe />
                              {edu2?.country}
                            </div>
                            <div className={styles.cardUnderItem}>
                              <AiOutlineFieldTime /> {deadLineEdu2} روز
                            </div>
                          </div>
                        </div>
                      </Link>
                    ) : (
                      "موردی یافت نشد"
                    )}
                  </div>
                )
              )}
            </div>
          </div>

          <Footer active="home" />
        </div>
      </div>
    </>
  );
}

export default Home;